<template>
  <!-- Confirmation Modal -->
  <div
    id="confirmationModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="confirmationModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5
            id="confirmationModalLabel"
            class="modal-title"
          >
            {{ $t('label.modal.CONFIRMATION_MODAL_LABEL') }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>
        <div class="modal-body">
          <div class="alert alert-warning">
            {{ $t('label.modal.CONFIRMATION_MODAL_MSG') }}
          </div>
        </div>
        <div class="modal-footer">
          <BaseButton
            type="button"
            data-bs-dismiss="modal"
            class="btn btn-primary"
            @click-base-button-event-emitter="$emit('action-confirmed-event')"
          >
            {{ $t('label.modal.CONFIRMATION_MODAL_YES_BUTTON') }}
          </BaseButton>
          <button
            type="button"
            class="btn rounded-pill btn-secondary font-custom"
            data-bs-dismiss="modal"
          >
            {{ $t('label.modal.CONFIRMATION_MODAL_NO_BUTTON') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/BaseButton'
import { Modal } from 'bootstrap'
export default {
  components: {
    BaseButton
  },
  props: {
  },
  emits: ['action-confirmed-event'],
  data () {
    return {
    }
  },
  created () {
  },

  methods: {
    showConfirmation () {
      let confirmationModal = new Modal(document.getElementById('confirmationModal'))
      confirmationModal.show()
    }
  }
}
</script>

<style scoped lang="scss">

</style>
